import { combineReducers } from "@reduxjs/toolkit";
import updateProductionEventDialogReducer from "./updateProductionEventSlice";
import productionEventHistoryDialogReducer from "./productionEventHistorySlice";

export default combineReducers({
  openUpdateProductionEventDialog: updateProductionEventDialogReducer,
  productionEventHistoryDialog: productionEventHistoryDialogReducer,
});
